<template>
  <div>
    <el-card shadow="always">
      <el-button size="small" type="primary" @click="saveDialog()" v-if="$isPerm('department-save')">添加</el-button>
      <el-button size="small" icon="el-icon-refresh" style="width: 80px; margin: 0 2px" @click="getData">刷新</el-button>
    </el-card>
    <el-table height="600" size="small" :data="tableData" border :default-expand-all="true" row-key="id" class="box-card mt10">
      <el-table-column prop="name" label="部门名称" width="220"> </el-table-column>
      <el-table-column prop="employee_qty" label="员工数" width="80"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="saveDialog(scope.row)" v-if="$isPerm('department-save')">编辑</el-button>
          <el-button size="mini" type="warning" @click="delData(scope.row.id)" v-if="$isPerm('department-delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="dialogTitle" :visible.sync="dialogShow" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <div style="padding: 20px">
        <el-form size="small" ref="formRef" :model="formData" label-width="120px">
          <el-form-item label="部门名称" prop="name">
            <el-input v-model="formData.name" style="width: 220px"></el-input>
          </el-form-item>
          <el-form-item label="上级部门" prop="parent_id">
            <el-cascader v-model="pids" :options="tableData" :props="{ checkStrictly: true, value: 'id', label: 'name' }" placeholder="一级部门" clearable style="width: 220px"></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <div class="form-but">
        <el-button size="small" type="primary" :loading="loading" @click="saveData()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'departmentList',
  components: {},
  inject: ['reload'],
  created() {
    this.getData();
  },
  data() {
    return {
      dialogTitle: '',
      dialogShow: false,
      loading: false,
      tableData: [],
      formData: {
        id: 0,
        parent_id: 0,
        name: ''
      },
      pids: []
    };
  },
  methods: {
    async getData() {
      await this.$api.department.tree().then(res => {
        if (res.code == 200) {
          this.tableData = res.data ?? [];
        }
      });
    },
    saveDialog(row) {
      this.pids = [];
      this.dialogShow = true;
      this.dialogTitle = '添加部门';
      if (row) {
        this.dialogTitle = '编辑部门';
        this.formData = row;
        const strArr = this.formData.path.split('-');
        const pids = strArr.slice(1, -1);
        this.pids = pids.map(item => +item);
      }
    },
    // 保存数据
    async saveData() {
      let data = _.cloneDeep(this.formData);
      data.parent_id = this.pids[this.pids.length - 1];
      // console.log(data, this.pids)
      this.loading = true;
      await this.$api.department.save(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.reload();
        }
      });
    },
    async delData(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$api.department.delete({ id: id }).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.reload();
            }
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    refresh() {
      this.dialogShow = false;
      this.getData();
    }
  }
};
</script>
